import { useCallback, useEffect } from "react";
import { decodeToken, getToken } from "../utils/authUtils";
import { useDispatch } from "react-redux";
import { setUserDatas } from "../features/userDatasSlice";

export default function useUserDatas({
	t,
	lang,
	setSnackbarMessage,
	setOpenSnackbar,
	setOpenBackdrop,
	navigate,
	handleLogout,
	skipInitialFetch = false,
}) {
	const dispatch = useDispatch();

	const fetchUserDatas = useCallback(async () => {
		try {
			const decodedUser = decodeToken();
			const userId = decodedUser?.id || null;
			const token = getToken();

			if (!userId || !token) {
				// 沒有 token＝從未登入或已登出，不是「過期」（2026-10-11）
				handleLogout({
					t,
					lang,
					setSnackbarMessage,
					setOpenSnackbar,
					setOpenBackdrop,
					navigate,
					logoutMessage: t("mapPage.loginRequired"),
				});
				return;
			}

			const response = await fetch(
				`${process.env.REACT_APP_API_URL}/users/${userId}`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);

			// 停權：後端 checkUser 對已簽出的 token 也回 403 account suspended（2026-10-16）
			if (response.status === 403) {
				const body = await response.json().catch(() => null);
				if (body?.error === "account suspended") {
					handleLogout({
						t,
						lang,
						setSnackbarMessage,
						setOpenSnackbar,
						setOpenBackdrop,
						navigate,
						logoutMessage: t("mapPage.accountSuspended"),
					});
					return;
				}
			}

			if (response.status === 401 || !response.ok) {
				handleLogout({
					t,
					lang,
					setSnackbarMessage,
					setOpenSnackbar,
					setOpenBackdrop,
					navigate,
					logoutMessage: t("mapPage.tokenExpired") || "認證失效，請重新登入",
				});
				return;
			}

			const data = await response.json();

			if (data && typeof data === "object") {
				dispatch(setUserDatas(data));
			}
		} catch (error) {
			handleLogout({
				t,
				lang,
				setSnackbarMessage,
				setOpenSnackbar,
				setOpenBackdrop,
				navigate,
				logoutMessage: t("mapPage.networkError") || "網路錯誤，請重新登入",
			});
		}
	}, [dispatch]);

	useEffect(() => {
		// console.log("skipInitialFetch", skipInitialFetch);
		// console.log("SkipInitialFetch type:", typeof(skipInitialFetch));
		if (!skipInitialFetch) {
			fetchUserDatas();
		}
		
	}, [skipInitialFetch, fetchUserDatas]);

	return { refreshUserDatas: fetchUserDatas };
}
